import { useA11yContext } from "@assets/spa/context/a11y";
import { Modal } from "@assets/tsx/modal";
import OutsideAlerter from "@assets/tsx/outsideClicker";
import Gallery from "@widgets/gallery/gallery";
import Image from "@widgets/image/image";
import { useI18n } from "@wordpress/react-i18n";
import React, { useState } from "react";
export default function PostTop({ date, time, image, title, featured_gallery }) {
    var _a;
    const hasGallery = ((_a = featured_gallery === null || featured_gallery === void 0 ? void 0 : featured_gallery.gallery) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const [modalOpen, setModalOpen] = useState(false);
    const [state] = useA11yContext();
    const has_image = (image === null || image === void 0 ? void 0 : image.url) && (state === null || state === void 0 ? void 0 : state.illustrations) === true;
    const { __ } = useI18n();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ltg-post-top ltg-post-top-responsive-tablet" },
            has_image && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "ltg-post-top-col" },
                    React.createElement("div", { className: `ltg-post-top-img-wrap${hasGallery ? ' --has-gallery' : ''}`, onClick: () => {
                            hasGallery && setModalOpen(true);
                        } },
                        (image === null || image === void 0 ? void 0 : image.url) && React.createElement(Image, { image: image, mask: "rounded" }),
                        hasGallery && React.createElement("span", { className: `ltg-card-icon type-white` },
                            React.createElement("i", { className: "fas fa-camera" })))))),
            React.createElement("div", { className: "ltg-post-top-col" },
                React.createElement("div", { className: "ltg-post-top-card" },
                    React.createElement("div", null,
                        React.createElement("h1", { className: "ltg-post-top-title" }, title),
                        React.createElement("p", { className: "ltg-post-top-date" },
                            __("Paskelbta", 'ltg-widgets'),
                            " ",
                            date,
                            " ",
                            time))))),
        hasGallery && React.createElement(Modal, { open: modalOpen },
            React.createElement(OutsideAlerter, { callback: () => { setModalOpen(false); } },
                React.createElement(GalleryModal, { gallery: [
                        {
                            _id: image.id + 'gallery-item',
                            image,
                        },
                        ...featured_gallery.gallery,
                    ] })))));
}
function GalleryModal({ gallery }) {
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ltg-gallery-modal-wrap", style: { width: '100vh' } },
            React.createElement(Gallery, { gallery: gallery })));
}
